
<style>
.shoot_box {
  padding-bottom: 10px;
  width:1280px;

  border-bottom: 1px solid rgb(204, 204, 204);
}
.shoot_title {
  font-size: 1.4rem;
}
.shoot_msg {
  margin-top: 10px;
  color: #666;
}
.shoot_content {
  min-height: 20rem;
  width:1280px;
  margin-top: 1.2rem;
}
.userful_box {
  text-align: center;
  padding: 20px;
}
.userful_box img {
  width: 3rem;
}
.userful_box div {
  color: #666;
}
</style>
<template>
  <div >
    <div class="m_tb_box m_tran50">
      <mt-header :title="title">
        <a @click="$router.go(-1)" slot="left">
          <mt-button icon="back">返回</mt-button>
        </a>
      </mt-header>

      <div v-if="titleArr.length>1">
        <table width="100%" class="m_tb_1" border="0" cellspacing="0" cellpadding="0">
          <tr class="m_tr_1">
            <td
              class="m_td_1"
              :class="currentIndex==index?'active': ''"
              @click="jump('jump'+index,index)"
              v-for="(item,index) in titleArr"
              :key="index"
            >
              <div class="m_aText">{{item}}</div>
              <div :class="currentIndex==index?'m_arrow': 'm_arrow_2'"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="shoot_box m_tran50">
      <div class="shoot_title">{{title}}</div>
      <div class="m_clearLR shoot_msg">
        <div class="m_floatL">发布日期：{{date|partFilter}}</div>
        <div class="m_floatR">{{view?view:'0'}}人阅读</div>
      </div>
    </div>
    <div class="shoot_content m_tran50"></div>
    <div class="userful_box">
      <img src="./../assets/images/userful.png" @click="userful">
      <div>{{num?num:'0'}}人觉得有用</div>
    </div>
  </div>
</template>

<script>
import { getArticleById, putThumbup } from "@/api/api";
import { MessageBox } from "mint-ui";
export default {
  data() {
    return {
      num: 0,
      id: -1,
      title: "无命题",
      view: 0,

      listLength: -1,
      titleArr: [],
      currentIndex: 0,
      baifen: "",
      date: "",
      baifen2: "",
      isFirst: false,
      timer: false
    };
  },
  filters: {
    partFilter(value) {
      if (!value) return "";
      var time = value.split("T")[0];
      var year = time.split("-");
      value = year[0] + "年" + year[1] + "月" + year[2] + "日";
      return value;
    }
  },
  created() {
    getArticleById(this.$route.query.id).then(res => {
      console.log(res);
      var down_info = document.querySelector(".shoot_content");
      down_info.innerHTML = res.data.body;
      this.num = res.data.useful;
      this.id = res.data.id;
      this.title = res.data.title;
      this.view = res.data.views;
      this.date = res.data.created_at;

      setTimeout(() => {
        var h2s = document.querySelectorAll("h2");
        this.listLength = h2s.length;
        setTimeout(() => {
          console.log(document.querySelector(".m_tb_box").clientHeight);
          document.querySelector(".shoot_box").style.marginTop =
            document.querySelector(".m_tb_box").clientHeight + 20 + "px";
        }, 10);
        if (h2s.length < 2) {
          return;
        }
        for (var i = 0; i < h2s.length; i++) {
          h2s[i].id = "jump" + i;
          this.titleArr.push(h2s[i].innerHTML);
        }

        setTimeout(() => {
          window.addEventListener("scroll", e => {
            if(this.timer==false){
              for(var i = 0 ; i < h2s.length-1 ; i++){
                var tempi = i
                var clientHeight = document.documentElement.clientHeight;
                var scrollTop = document.documentElement.scrollTop;
                var scrollHeight = document.documentElement.scrollHeight;
                console.log(clientHeight)
                console.log(scrollTop)
                console.log(scrollHeight)
                if(document.documentElement.scrollTop+115>($("#jump"+tempi ).offset().top)&&document.documentElement.scrollTop+115<($("#jump"+(tempi+1) ).offset().top)){
                  // if(i>=4){
                  console.log($("#jump"+tempi ).offset().top+'----'+i)
                  //    document.querySelector('.m_tr_1').scrollLeft +=88;

                  // }else{
                  //   document.querySelector('.m_tr_1').scrollLeft -=88;
                  // }

                  if(this.listLength>4)
                    document.querySelector('.m_tr_1').scrollLeft =(88*(i-1));
                  this.currentIndex = i

                  break;
                  //
                }else if(document.documentElement.scrollTop+85>($("#jump"+(h2s.length-1)).offset().top)||(scrollHeight-30<=(scrollTop+clientHeight))){
                  if(this.listLength>4)
                    document.querySelector('.m_tr_1').scrollLeft =(88*(h2s.length-1));
                  this.currentIndex = h2s.length-1
                  break;
                }

              }

            }
          });

          var tds = document.querySelectorAll(".m_td_1");
          for (var i = 0; i < tds.length; i++) {
            if (tds.length <= 4) {
              document.querySelector(".m_tr_1").style.overflowX = "hidden";
              tds[i].style.width = 25.14 / h2s.length + "rem";
              tds[i].style.width = 25.14 / h2s.length - 1.286 + "rem";
              tds[i].style.paddingLeft = "1.285rem";
            } else {
              tds[i].style.width = "6.285rem";
              tds[i].style.width = 6.285 - 1.286 + "rem";
              tds[i].style.paddingLeft = "1.285rem";
            }
          }
        }, 10);
      }, 10);
    });
  },
  methods: {
    userful() {
      putThumbup(this.id).then(res => {
        if (res.data.status == "true") {
          this.num++;
          MessageBox("提示", "点赞成功");
        } else MessageBox("提示", "亲,不能重复点赞！");
      });
    },
    jump(id, index) {
      if (this.listLength > 4)
        document.querySelector(".m_tr_1").scrollLeft = 88 * index;

      this.timer = true;
      setTimeout(() => {
        this.timer = false;
      }, 500);
      this.currentIndex = index;
      $("html, body").animate(
        {
          scrollTop: $("#" + id).offset().top - 95
        },
        { duration: 200, easing: "swing" }
      );
      return false;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/troubleshootingInfo.vue